/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ImageDTO } from "../models";
import { ImageDTOFromJSON, ImageDTOToJSON } from "../models";

/**
 *
 */
export class ImagesApi extends runtime.BaseAPI {
  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async createRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImageDTO>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/images`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ImageDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async create(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImageDTO> {
    const response = await this.createRaw(initOverrides);
    return await response.value();
  }
}
